import "./app.scss";
import ServiceForm from "./components/ServiceForm";
import "./assets/scss/cconsent-bar.css";

function App() {
    return (
        <>
            <nav className="header">
                <div className="top-row">
                    <a className="logo-wrapper" href="https://www.skoda-auto.pl/" target="_self" aria-label="Škoda logo"></a>
                </div>
                <div className="bottom-row">
                    <a href="https://www.skoda-auto.pl/" target="_self">Przejdź do&nbsp;strony głównej</a>
                </div>
            </nav>

            <div className="main-container">
                <div className="form-wrapper">
                    <ServiceForm/>
                </div>
            </div>
        </>
    );
}

export default App;
